// Reducer
import cloneDeep from 'lodash/cloneDeep'
import debounce from 'lodash/debounce'
import throttle from 'lodash/throttle'
import * as immu from 'object-path-immutable'
import { createStore } from "redux"
import middleware from './middleware'

import * as xeon from '../data-thunk/xeon';


// ---------------------
// Reducer
// ---------------------
function reducer( state, action ) {
  if ( action.data !== undefined ) {
    return immu.set( state, action.type, cloneDeep( action.data ) )
  } else {
    return immu.del( state, action.type )
  }
}

// ----------------------------
// Try to load previous state
// ----------------------------
let state = {
  view: {
    // Global
    hidden: true,
    // Height of nice blue banner according to data-thunk/height
    height: "auto",
    // Height of book to push footer down
    space: "calc( 100vh - 300px - 2rem - 3rem )",
    // Previous view
    prev: null
  },
  xeon: {
    id: null,
    drugs: {},
    rules: {},
    faqs: {},
    pmids: {}
  }
}

// -------------------------------
// Trying to recover from reload
// -------------------------------
try {
  const save = JSON.parse( sessionStorage.getItem( "clinic" ) )
  if ( save != null ) {
    state = save
  }
} catch ( err ) {
  console.log( err.message )
}

// ---------------------------
// Create fresh store
// ---------------------------
const store = createStore( reducer, state, middleware() )

// --------------------------------
// Save selected parts from store
// --------------------------------
store.subscribe( throttle( () => {
  // Keys can be filtered here
  sessionStorage.setItem( "clinic", JSON.stringify( getState() ) )
}, 500 ) )

// -------------------------------
// Persist xeon data to elastic
// -------------------------------
store.subscribe( throttle( () => {
  const state = store.getState()
  if ( state.xeon.id ) {
    if ( process.env.NODE_ENV == "develop" ) {
      // console.log( "> xeon save" )
    }
    return store.dispatch( xeon.save() )
  }
}, 20000 ) )

// ----------------------------
// Exports
// ----------------------------
export default store
// Easy access
export const dispatch = store.dispatch
export const getState = store.getState
export const subscribe = store.subscribe
